'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const getLinkedList = (id, list) => {
    if (list.items[id]) {
        return list.items[id];
    }
    return null;
};

exports.getLinkedList = getLinkedList;
//# sourceMappingURL=get-linked-list.js.map
